/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

export class TimeRecordingComponentKey {
  static readonly LOGIN = 'time-recording/component/login';
  static readonly TIME_RECORDING_ROOT = 'time-recording/component/time-recording-root';
  static readonly TIME_RECORDING_CONTENT = 'time-recording/component/time-recording-content';
  static readonly TIME_RECORDING_TABLE = 'time-recording/component/time-recording-table';
  static readonly TIME_RECORDING_SIDEBAR = 'time-recording/component/time-recording-sidebar';
  static readonly PROJECT_TIME_RECORDING_TABLE = 'time-recording/component/project-time-recording-table';
  static readonly PROJECT_TIME_RECORDING = 'time-recording/component/project-time-recording';
  static readonly PROJECT_MANAGEMENT = 'time-recording/component/project-management';
  static readonly PROJECT_ACTIVITIES = 'time-recording/component/project-activities';
  static readonly PROJECT_ACTIVITIES_TABLE = 'time-recording/component/project-activities-table';
  static readonly ASSIGN_TOKEN_DIALOG = 'time-recording/component/assign-token-dialog';
  static readonly ASSIGN_PIN_DIALOG = 'time-recording/component/assign-pin-dialog';
  static readonly EMPLOYEE_DETAIL = 'time-recording/component/employee-detail';
  static readonly EMPLOYEE_DURATION = 'time-recording/component/employment-duration';
  static readonly PROJECT_INPUT = 'time-recording/component/project-input';
  static readonly PROJECT_AUTO_COMPLETE_INPUT = 'time-recording/component/project-autocomplete-input';
}
